import { css } from "lit";

/** The pane's CSS custom properties with their default values, as declarations */
export const tokenDeclarations = css`
    --fields-pane-font-family: Calibri, helvetica, arial, sans-serif;
    --fields-pane-font-size: 12px;
    --fields-pane-bucket-background: #fff;
    --fields-pane-bucket-border: 1px dashed #c8c6c4;
    --fields-pane-bucket-width: 160px;
    --fields-pane-bucket-min-height: 24px;
    --fields-pane-field-background: #edebe9;
    --fields-pane-field-hover-background: #c7c6c4;
    --fields-pane-field-border: 1px solid #c8c6c4;
    --fields-pane-field-height: 20px;
    --fields-pane-field-width: 154px;
    --fields-pane-radius: 2px;
    --fields-pane-edit-button-hover-background: #edebe9;
    --fields-pane-marker-color: #605e5c;
    --fields-pane-drop-target-border: 1px dashed #0078d4;
    --fields-pane-drop-target-background: #eff6fc;
    --fields-pane-drop-active-border: 1px solid #0078d4;
    --fields-pane-drop-active-background: #c7e0f4;
    --fields-pane-faded-opacity: 0.45;
    --fields-pane-insertion-color: #0078d4;
    --fields-pane-transition: 0.12s ease-out;
`;

/**
 * The CSS custom properties the pane is styled with, set on the pane's host, so a host stylesheet can override any
 * of them, for example `fields-pane { --fields-pane-field-background: #fff; }`.
 */
export default css`
    :host {
        ${tokenDeclarations}
    }
`;
